import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from 'src/app/loader.service';
import { SharedService } from 'src/app/shared/shared.service';
import { Toaster, ToasterType } from 'src/app/shared/types/toaster.types';
import { ToasterService } from 'src/app/toaster.service';
import { AUTHZ_FEATURES } from 'src/app/constants/permissions';
import { AuthzAccessHintService } from 'src/app/shared/authz-access-hint/authz-access-hint.service';
var IDENTIFIERS = {
    CITY: 'CITY',
    SHIFT: 'SHIFT',
    SERVICE: 'SERVICE'
};
var AMOUNT_FIELDS = [
    {
        key: 'negativeBalanceWarn',
        label: 'Warning limit for negative balance',
        placeholder: '0',
        limitType: 'NEGATIVE_BALANCE_WARN',
        warning: true
    },
    {
        key: 'negativeBalanceBlock',
        label: 'Block limit for negative balance',
        placeholder: '0',
        limitType: 'NEGATIVE_BALANCE',
        warning: false
    },
    {
        key: 'negativeDueBalanceWarn',
        label: 'Warning limit for negative due balance',
        placeholder: '0',
        limitType: 'NEGATIVE_DUE_BALANCE_WARN',
        warning: true
    },
    {
        key: 'negativeDueBalanceBlock',
        label: 'Block limit for negative due balance',
        placeholder: '0',
        limitType: 'NEGATIVE_DUE_BALANCE',
        warning: false
    }
];
var LimitStoreCreateComponent = /** @class */ (function () {
    function LimitStoreCreateComponent(sharedService, loader, toasterService, authzAccessHintService) {
        this.sharedService = sharedService;
        this.loader = loader;
        this.toasterService = toasterService;
        this.authzAccessHintService = authzAccessHintService;
        this.amountFields = AMOUNT_FIELDS;
        this.limitForm = new FormGroup({
            city: new FormControl(null, [Validators.required]),
            shift: new FormControl(null),
            service: new FormControl(null),
            negativeBalanceWarn: new FormControl(null),
            negativeBalanceBlock: new FormControl(null),
            negativeDueBalanceWarn: new FormControl(null),
            negativeDueBalanceBlock: new FormControl(null),
            priority: new FormControl(1, [Validators.required]),
            active: new FormControl(true)
        });
        this.cities = [];
        this.shifts = [];
        this.services = [];
        this.submitting = false;
        this.authzAccessHint = null;
        this.subs = [];
    }
    LimitStoreCreateComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAccessHint();
        this.fetchCities();
        this.subs.push(this.limitForm.get('city').valueChanges.subscribe(function () {
            _this.limitForm.get('shift').setValue(null);
            _this.limitForm.get('service').setValue(null);
            _this.shifts = [];
            _this.services = [];
            var city = _this.limitForm.get('city').value;
            if (city) {
                _this.fetchShifts(city.name);
                _this.fetchServices(city.id);
            }
        }));
    };
    LimitStoreCreateComponent.prototype.ngOnDestroy = function () {
        this.subs.forEach(function (s) { return s.unsubscribe(); });
    };
    LimitStoreCreateComponent.prototype.loadAccessHint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.authzAccessHintService.getAccessHintData(AUTHZ_FEATURES.LIMIT_STORE)];
                    case 1:
                        _a.authzAccessHint = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LimitStoreCreateComponent.prototype.hasAmount = function (value) {
        return value !== null && value !== undefined && value !== '';
    };
    LimitStoreCreateComponent.prototype.fieldError = function (key) {
        var raw = this.limitForm.get(key).value;
        if (!this.hasAmount(raw)) {
            return null;
        }
        var amount = Number(raw);
        if (!Number.isFinite(amount) || !Number.isInteger(amount) || amount >= 0) {
            return 'Positive values are not allowed. Enter a negative integer (e.g. -30).';
        }
        return null;
    };
    Object.defineProperty(LimitStoreCreateComponent.prototype, "hasAmountError", {
        get: function () {
            var _this = this;
            return this.amountFields.some(function (field) { return !!_this.fieldError(field.key); });
        },
        enumerable: true,
        configurable: true
    });
    LimitStoreCreateComponent.prototype.stopAmountScroll = function (event) {
        var target = event.target;
        if (target && target.tagName === 'INPUT' && target.type === 'number') {
            target.blur();
        }
    };
    LimitStoreCreateComponent.prototype.blockNonIntegerKey = function (event) {
        var blocked = ['e', 'E', '+', '.', ','];
        if (blocked.indexOf(event.key) !== -1) {
            event.preventDefault();
        }
    };
    LimitStoreCreateComponent.prototype.blockNonIntegerPaste = function (event) {
        var pasted = event.clipboardData && event.clipboardData.getData('text');
        if (!pasted || !/^-?[0-9]+$/.test(pasted.trim())) {
            event.preventDefault();
        }
    };
    LimitStoreCreateComponent.prototype.fetchCities = function () {
        var _this = this;
        this.loader.openLoading();
        this.sharedService.fetchCities().toPromise()
            .then(function (res) {
            _this.cities = ((res && res.data && res.data.cities) || [])
                .filter(function (city) { return city.active !== false; })
                .map(function (city) { return ({ id: city._id, name: city.displayName }); });
        })
            .catch(function () {
            _this.showWarning('Error fetching cities');
        })
            .finally(function () { return _this.loader.closeLoading(); });
    };
    LimitStoreCreateComponent.prototype.fetchShifts = function (cityDisplayName) {
        var _this = this;
        if (!cityDisplayName) {
            return;
        }
        this.sharedService.fetchShifts(cityDisplayName).toPromise()
            .then(function (res) {
            var data = Array.isArray(res) ? res : (res && res.data ? res.data : []);
            _this.shifts = (data || []).filter(Boolean);
        })
            .catch(function () {
            _this.shifts = [];
            _this.showWarning('Error fetching shifts');
        });
    };
    LimitStoreCreateComponent.prototype.fetchServices = function (cityId) {
        var _this = this;
        if (!cityId) {
            return;
        }
        this.sharedService.cityService(cityId).toPromise()
            .then(function (res) {
            var mapped = ((res && res.data) || [])
                .filter(function (sd) { return sd && sd.active !== false && sd.service; })
                .map(function (sd) { return ({
                id: sd.service._id,
                name: sd.service.name
            }); });
            var seen = {};
            _this.services = mapped.filter(function (svc) {
                if (!svc.id || seen[svc.id]) {
                    return false;
                }
                seen[svc.id] = true;
                return true;
            });
        })
            .catch(function () {
            _this.services = [];
            _this.showWarning('Error fetching services');
        });
    };
    LimitStoreCreateComponent.prototype.createLimit = function () {
        var _this = this;
        var validationError = this.validateForm();
        if (validationError) {
            this.showWarning(validationError);
            return;
        }
        var payloads = this.buildPayloads();
        this.submitting = true;
        this.loader.openLoading();
        this.createSequentially(payloads, 0, { pending: 0, saved: 0 })
            .then(function (counts) {
            _this.showSuccess(_this.successMessage(counts));
            _this.resetAmounts();
        })
            .catch(function (error) {
            _this.showWarning(_this.readError(error));
        })
            .finally(function () {
            _this.submitting = false;
            _this.loader.closeLoading();
        });
    };
    LimitStoreCreateComponent.prototype.createSequentially = function (payloads, index, counts) {
        var _this = this;
        if (index >= payloads.length) {
            return Promise.resolve(counts);
        }
        return this.sharedService.createLimit(payloads[index]).toPromise()
            .then(function (res) {
            var outcome = _this.readCreateOutcome(res);
            if (outcome === 'PENDING_APPROVAL') {
                counts.pending += 1;
            }
            else if (outcome === 'SAVED') {
                counts.saved += 1;
            }
            return _this.createSequentially(payloads, index + 1, counts);
        });
    };
    LimitStoreCreateComponent.prototype.readCreateOutcome = function (res) {
        var data = res && res.data;
        if (data && data.outcome) {
            return data.outcome;
        }
        var payload = data && data.data;
        if (payload && payload.status === 'PENDING_APPROVAL') {
            return 'PENDING_APPROVAL';
        }
        if (payload && payload.limitType) {
            return 'SAVED';
        }
        return 'UNKNOWN';
    };
    LimitStoreCreateComponent.prototype.successMessage = function (counts) {
        var pending = counts.pending, saved = counts.saved;
        if (saved > 0 && pending === 0) {
            return saved === 1
                ? 'Limit saved. It is visible in the list.'
                : saved + " limits saved. They are visible in the list.";
        }
        if (pending > 0 && saved === 0) {
            return pending === 1
                ? 'Submitted for checker approval. The limit appears in the list after approval.'
                : pending + " limits submitted for checker approval. They appear in the list after approval.";
        }
        if (pending > 0 && saved > 0) {
            return saved + " limit(s) saved immediately; " + pending + " pending checker approval.";
        }
        return 'Limits submitted successfully.';
    };
    LimitStoreCreateComponent.prototype.resolveIdentifiers = function () {
        var city = this.limitForm.get('city').value;
        var shift = this.limitForm.get('shift').value;
        var service = this.limitForm.get('service').value;
        if (!city) {
            return { error: 'City is required' };
        }
        var scopes = [];
        if (shift) {
            scopes.push({ identifier: IDENTIFIERS.SHIFT, identifierId: shift });
        }
        if (service) {
            scopes.push({ identifier: IDENTIFIERS.SERVICE, identifierId: service.id });
        }
        if (scopes.length === 0) {
            scopes.push({ identifier: IDENTIFIERS.CITY, identifierId: city.id });
        }
        return scopes;
    };
    LimitStoreCreateComponent.prototype.validateForm = function () {
        var _this = this;
        var resolved = this.resolveIdentifiers();
        if (resolved.error) {
            return resolved.error;
        }
        var filled = this.amountFields.filter(function (field) { return _this.hasAmount(_this.limitForm.get(field.key).value); });
        if (!filled.length) {
            return 'Enter at least one limit';
        }
        var invalid = filled.find(function (field) { return _this.fieldError(field.key) !== null; });
        if (invalid) {
            return this.fieldError(invalid.key);
        }
        var priority = Number(this.limitForm.get('priority').value);
        if (!Number.isFinite(priority) || priority < 1) {
            return 'Priority must be a positive number';
        }
        return null;
    };
    LimitStoreCreateComponent.prototype.buildPayloads = function () {
        var _this = this;
        var city = this.limitForm.get('city').value;
        var scopes = this.resolveIdentifiers();
        var priority = Number(this.limitForm.get('priority').value);
        var active = !!this.limitForm.get('active').value;
        var payloads = [];
        scopes.forEach(function (scope) {
            _this.amountFields.forEach(function (field) {
                var raw = _this.limitForm.get(field.key).value;
                if (!_this.hasAmount(raw)) {
                    return;
                }
                var amount = Number(raw);
                payloads.push({
                    identifier: scope.identifier,
                    identifierId: scope.identifierId,
                    city: city.id,
                    limitType: field.limitType,
                    limit: amount,
                    priority: priority,
                    active: active,
                    metadata: {
                        negativeBalanceWarn: field.warning ? amount : undefined,
                        minRechargeAmountRanges: [],
                        negBalanceSelectedServicesAllowed: false
                    }
                });
            });
        });
        return payloads;
    };
    LimitStoreCreateComponent.prototype.resetAmounts = function () {
        var _this = this;
        this.amountFields.forEach(function (field) {
            _this.limitForm.get(field.key).setValue(null, { emitEvent: false });
        });
    };
    LimitStoreCreateComponent.prototype.readError = function (error) {
        var body = error && error.error;
        var nested = body && body.data && body.data.error;
        return (body && body.message)
            || (nested && nested.message)
            || (error && error.message)
            || 'Could not submit limit';
    };
    LimitStoreCreateComponent.prototype.showWarning = function (message) {
        this.toasterService.showToaster(new Toaster({ type: ToasterType.WARNING, message: message }));
    };
    LimitStoreCreateComponent.prototype.showSuccess = function (message) {
        this.toasterService.showToaster(new Toaster({ type: ToasterType.SUCCESS, message: message }));
    };
    return LimitStoreCreateComponent;
}());
export { LimitStoreCreateComponent };
